import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { SvgDraggable, SvgDragService } from './svg-drag.service';

@Directive({ selector: '[svgDrag]' })
export class SvgDragDirective implements OnInit, OnDestroy, SvgDraggable {
  @Input() svgDragDisabled = false;
  @Input() svgDragIndex = -1;

  constructor(private elementReference: ElementRef<SVGGraphicsElement>, private dragService: SvgDragService) {}

  ngOnInit() {
    this.dragService.register(this);
  }

  ngOnDestroy() {
    this.dragService.unregister(this);
  }

  getRect(): DOMRect {
    return this.elementReference.nativeElement.getBoundingClientRect();
  }

  getIndex(): number {
    return this.svgDragIndex;
  }

  isDisabled(): boolean {
    return this.svgDragDisabled;
  }

  setTranslate(dx: number, dy: number): void {
    const transform = 'translate(' + dx + ' ' + dy + ')';
    this.elementReference.nativeElement.setAttributeNS(null, 'transform', transform);
  }
}
